import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  baseUrl: string = '/accreditation/api/Notification';

  constructor(private http: HttpClient) {}

  getNotifications(
    personId: string,
    pageIndex: number,
    pageSize: number,
    unread?: boolean
  ): Observable<any> {
    const paginationInfo = {
      CurrentPage: pageIndex,
      PagingSize: pageSize,
    };
    const headers = new HttpHeaders().set(
      'X-Filter',
      JSON.stringify(paginationInfo)
    );

    let params = new HttpParams();
    if (unread) params = params.append('unread', `${unread}`);

    return this.http.get<any>(`${this.baseUrl}/notifications/${personId}`, {
      headers,
      observe: 'response',
      params,
    });
  }

  getUnreadNotificationsCount(personId: string): Observable<number> {
    return this.http.get<any>(
      `${this.baseUrl}/notifications-count/${personId}`
    );
  }

  setNotificationRead(id: string) {
    return this.http.put(`${this.baseUrl}/set-read/${id}`, {});
  }

  deleteNotification(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }
}
